module.exports = __webpack_public_path__ + "static/media/14.44c9f53f.jpg";